// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3ZSAQ","productName":"Table_productName__2JKhY"};